<template>
    <div class="user-social-picker">
        <h4 class="input-title"> {{ kStrings.kPERSONAL_PAGE }} </h4>
        <div class="radio-picker-wrapper">
            <div class="social-radio-wrapper">
                <i class="ecom-facebook"/>
                <input v-model="pickerData.type" type="radio" id="social-fb" name="socialRadio" value="fb" @input="onInput">
                <label for="social-fb"> <span/> </label>
            </div>
            <div class="social-radio-wrapper">
                <i class="ecom-tiktok"/>
                <input v-model="pickerData.type" type="radio" id="social-tiktok" name="socialRadio" value="tk" @input="onInput">
                <label for="social-tiktok"> <span/> </label>
            </div>
            <div class="social-radio-wrapper">
                <i class="ecom-instagram"/>
                <input v-model="pickerData.type" type="radio" id="social-instagram" name="socialRadio" value="itg" @input="onInput">
                <label for="social-instagram"> <span/> </label>
            </div>
            <div class="social-radio-wrapper">
                <i class="ecom-youtube"/>
                <input v-model="pickerData.type" type="radio" id="social-youtube" name="socialRadio" value="yt" @input="onInput">
                <label for="social-youtube"> <span/> </label>
            </div>
            <div class="social-radio-wrapper">
                <i class="ecom-pinterest"/>
                <input v-model="pickerData.type" type="radio" id="social-pinterest" name="socialRadio" value="ptr" @input="onInput">
                <label for="social-pinterest"> <span/> </label>
            </div>
            <div class="social-radio-wrapper">
                <i class="ecom-twitter"/>
                <input v-model="pickerData.type" type="radio" id="social-twitter" name="socialRadio" value="twt" @input="onInput">
                <label for="social-twitter"> <span/> </label>
            </div>
            <div class="social-radio-wrapper">
                <i class="ecom-link-off"/>
                <input v-model="pickerData.type" type="radio" id="social-link-off" name="socialRadio" value="linkoff" @input="onInput">
                <label for="social-link-off"> <span/> </label>
            </div>
        </div>
        <div class="input-wrapper">
            <input v-model="pickerData.link" id="socialLink" type="text" maxlength="50" class="normal-input" :disabled="pickerData.type == 'linkoff'" @input="onInput" required>
            <label for="socialLink"> {{ kStrings.kLINK }} </label>
        </div>
    </div>
</template>

<script>

import {store} from '@/store/pastimes';
//import {isEmpty} from 'lodash-es';

export default {
    store,
    name: 'SocialNetworkPicker',
    components: {},
    props: {
        //prop1: {type: Object, default: null, required: false}
    },
    data() {
        return {
           /* mediaModel: 'linkoff',
            linkModel: '',*/
            pickerData: {
                type: 'linkoff',
                link: ''
            }
        }
    },
    computed: {
        kStrings() {
            return this.$store.getters.kStrings;
        },
    },
    watch: {
        pickerData: {
            deep: true,
            handler: function (value, oldValue) {
                if(value.type == 'linkoff') {
                    this.pickerData.link = '';
                }
                // emit here?
            }
        }
    },
    mounted() {
    },
    methods: {
        /*onSocialInput(event) {
            //const value = event.target.value;
            if(this.mediaModel == 'linkoff') {
                this.linkModel = '';
            }
            
            const pickerData = {
                type: this.mediaModel,
                link: this.linkModel
            };
            
            this.$emit('input', pickerData);
        },*/
        onInput() {
            this.$emit('input', this.pickerData);
        }
    }
};
</script>

<style scoped>

</style>